const features = [
  {
    icon: 'ri-4k-line',
    title: '蓝光画质',
    desc: '多线高清片源，支持 1080P 与 4K 蓝光画质，搭配影院级音效，还原每一个画面细节，享受沉浸式观影体验。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅不卡顿',
    desc: '自研智能加速引擎，多节点 CDN 分发，无论热门大片还是冷门佳片，都能实现秒加载、不缓冲的极致流畅播放。',
  },
  {
    icon: 'ri-film-line',
    title: '海量片库',
    desc: '涵盖电影、电视剧、综艺、动漫、纪录片等全品类，超过两万部影视资源，每日持续更新最新热门内容。',
  },
  {
    icon: 'ri-user-line',
    title: '无需注册',
    desc: '打开即看，无需注册登录，无需绑定手机。我们相信好的观影体验不应该有任何门槛和繁琐流程。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '支持电脑、平板、手机等多种设备访问，自动适配屏幕尺寸，无论在家还是出行都能畅享一致的观影体验。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            极致体验
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            从画质到速度，从片库到体验，春夜影院用心打磨每一个细节
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.slice(0, 2).map((f, idx) => (
            <div
              key={idx}
              className="lg:col-span-2 bg-background-50 rounded-lg p-6 md:p-8 flex flex-col sm:flex-row gap-5 items-start"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 shrink-0">
                <i className={`${f.icon} text-accent-500 text-2xl`}></i>
              </div>
              <div>
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
                  {f.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
              </div>
            </div>
          ))}

          {features.slice(2).map((f, idx) => (
            <div
              key={idx + 2}
              className="bg-background-50 rounded-lg p-5 md:p-6"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100 mb-4">
                <i className={`${f.icon} text-secondary-500 text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2">
                {f.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}